export default __webpack_public_path__ + "static/media/15.12413fa0.png";